export default {
  error: {
    buttons: {
      back: 'Return',
      login: 'Re-enter',
      logOut: 'Log Out',
    },
    inactive: {
      title: 'You have timed out and have become inactive.',
      detail: 'That\'s all we know.',
      message: 'Code No.',
    },
    locked: {
      title: 'You have timed out and have become inactive.',
      detail: 'That\'s all we know.',
      message: 'Code No.',
    },
    auth: {
      title: 'An error has occurred',
      detail: 'Sorry, something is going wrong when entering cat4mro',
      message: 'Code No.',
    },
    page401: {
      title: '401 Unauthorized',
      detail: 'You do not have permission for the requested URL.',
      message: 'Please try again by logging in.',
    },
    page404: {
      title: '404 Not Found',
      detail: 'The requested URL was not found on this server.',
      message: 'That\'s all we know.',
    },
    page500: {
      title: '500 A problem occurred',
      detail: 'The requested URL was not found on this server.',
      message: 'That\'s all we know.',
    },
    pageContactTechSupport: {
      title: 'Something went wrong',
      detail: 'Please contact tech support.',
      message: 'They will help resolve the problem.',
      redirect: 'Your session will be closed automatically in ',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/error.js